<section>
    <div class="container-fluid formBoxCenterCon loginCon ">
        <div class="container  h-100">
            <div class="row justify-content-center  h-100">
                <div class="col-sm-12 col-md-10 col-lg-8 col-xl-6 align-self-center">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</section>